var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialMediaX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.49,3.09h5.07l-11.06,12.63,13,17.19h-10.18l-7.99-10.42-9.12,10.42H2.14l11.82-13.51L1.5,3.09h10.44l7.2,9.52L27.47,3.09h.02ZM25.72,29.89h2.81L10.43,5.96h-3l18.3,23.92h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialMediaX);
export default __webpack_public_path__ + "static/media/icon-social-media-x.ffdc23e38af90915d9d2bf215a0655c9.svg";
export { ForwardRef as ReactComponent };